// Add your custom JS here.

jQuery(document).ready(function($) {
$(window).scroll(function() {
	if ($(this).scrollTop() > 57){  
		$('#wrapper-navbar').addClass("sticky");
	}
	else{
		$('#wrapper-navbar').removeClass("sticky");
	}
});
});

jQuery(document).ready(function($) {
		// Close ShiftNav menu when a navigation link is clicked
		$('.shiftnav a').on('click', function () {
			if ($(this).attr('href') !== '#') {
				$('.shiftnav-open-target').removeClass('shiftnav-open-target'); // Close the menu
			}
		});
});


jQuery(document).ready(function($) {
	document.addEventListener('DOMContentLoaded', function () {
	  // Find all <li> elements with the "open-modal" class
	  document.querySelectorAll('.shiftnav li.open-modal').forEach(function (listItem) {
		// Get the <a> tag inside the <li>
		const link = listItem.querySelector('a');
		if (link) {
		  // Add Bootstrap modal attributes to the <a> tag
		  link.setAttribute('data-bs-toggle', 'modal');
		  link.setAttribute('data-bs-target', '#exampleModal');
		}
	  });
	});
});



// PAGE IMAGE SLIDER
jQuery(document).ready(function($) {
	$('.page-image-slider').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		$slider.slick({
			dots: true,
			adaptiveHeight: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
		});
	});
});